import { NbMenuItem } from "@nebular/theme";

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: "Dashboard",
    icon: "home-outline",
    link: "/pages/dashboard",
    home: true,
    data: {
     moduleId: 1, moduleName: "Dashboard", SubModuleId: null, SubModuleName: null
    }
  },
  {
    title: "User Insights",
    icon: "people-outline",
    link: "/pages/analytics/user-insights",
    data: {
      moduleId: 2, moduleName: "User Insights", SubModuleId: null, SubModuleName: null,
      expectedRoles: ["SYS_ADMIN", "ADMIN"],
    },
  },
  {
    title: "WAREHOUSE MANAGEMENT",
    group: true,
  },
  {
    title: "Reports",
    icon: "pie-chart-outline",
    children: [
      {
        title: "Stock / Transaction Report",
        link: "/pages/reports/stock",
        icon: "swap-outline",
        data: { moduleId: 3, moduleName: "Reports", SubModuleId: 1, SubModuleName: "Stock / Transaction Report" }
      },
      {
        title: "KPI Report",
        link: "/pages/reports/kpi",
        icon: "bar-chart-outline",
        data: { moduleId: 3, moduleName: "Reports", SubModuleId: 2, SubModuleName: "KPI Report" }
      },
    ],
  },
  {
    title: "ASN",
    icon: { icon: "truck-reverse", pack: "custom-svg" },
    link: "/pages/warehouse/asn/list",
    data: { moduleId: 4, moduleName: "ASN", SubModuleId: null, SubModuleName: null }
  },
  {
    title: "Shipment Order",
    icon: { icon: "truck", pack: "fa" },
    link: "/pages/warehouse/shipment-order/list",
    data: { moduleId: 5, moduleName: "Shipment Order", SubModuleId: null, SubModuleName: null }
  },
  {
    title: "Inventories",
    icon: "archive-outline",
    link: "/pages/inventories/list",
    data: { moduleId: 6,  moduleName: "Inventories", SubModuleId: null, SubModuleName: null }
  },
  {
    title: "Items",
    icon: "shopping-bag-outline",
    link: "/pages/configuration/items/list",
    data: { moduleId: 7, moduleName: "Items",  SubmoduleId: null, SubModuleName: null }
  },
  {
    title: "SUPPORT",
    group: true,
    // data:{
    //   expectedRoles:['SYS_ADMIN','ADMIN','CUSTOMER_SERVICE']
    // },
  },
  {
    title: "Service Request",
    icon: "phone-call-outline",
    // data:{
    //   expectedRoles:['SYS_ADMIN','ADMIN']
    // },
    children: [
      {
        title: "Create Service Request",
        link: "/pages/support/service-requests/create",
        icon: "plus",
        data: { moduleId: 8, moduleName: "Service Request", SubmoduleId: 1, SubModuleName: "Create Service Request" }
      },
      {
        title: "Track Support Tickets",
        link: "/pages/support/service-requests/track-tickets",
        icon: "list-outline",
        data: { moduleId: 8, moduleName: "Service Request", SubModuleId: 2, SubModuleName: "Track Support Tickets" }
      },
      // {
      //   title: 'View Archived Tickets',
      //   link: '/pages/support/service-requests/archive-tickets',
      //   icon: 'list-outline'
      // }
    ],
  },
  {
    title: "Live Chat",
    icon: "message-square-outline",
    children: [
      {
        title: "Start a conversation",
        link: "/pages/support/live-chat/start",
        icon: "message-circle-outline",
        data: { moduleId: 9, moduleName: "Live Chat", SubModuleId: 1, SubModuleName: "Start a Conversation" }
      },
      
    ],
  },
  { 
    title: "SETTINGS",
    group: true,
    data: {
      expectedRoles: ["SYS_ADMIN", "ADMIN", "CUSTOMER_SERVICE"],
    },
  },
  {
    title: "User Management",
    icon: "people-outline",
    data: {
      moduleId: 10, moduleName: "User Management",
      expectedRoles: ["SYS_ADMIN", "ADMIN", "CUSTOMER_SERVICE"],
    },
    children: [
      // {
      //   title: 'Users Groups',
      //   link: '/pages/users/group/list',
      //   icon: 'list-outline',
      //   data:{
      //     expectedRoles:['SYS_ADMIN','ADMIN']
      //   },
      // },
      // {
      //   title: 'Add New User Group',
      //   link: '/pages/users/group/register',
      //   icon: 'plus',
      //   data:{
      //     expectedRoles:['SYS_ADMIN','ADMIN']
      //   },
      // },
      {
        title: "Users List",
        link: "/pages/users/list",
        icon: "people-outline",
        data: { moduleId: 10, moduleName: "User Management", SubModuleId: 1, SubModuleName: "Users List", expectedRoles: ["SYS_ADMIN", "ADMIN"], },
      },
      {
        title: "Reset Password",
        link: "/pages/users/reset-password",
        icon: "edit-outline",
        data: { moduleId: 10, moduleName: "User Management", SubModuleId: 2, SubModuleName: "Reset Password", expectedRoles: ["SYS_ADMIN", "ADMIN"], },
      },
      {
        title: "Profile",
        link: "/pages/users/profile",
        icon: "person-outline",
        data: { moduleId: 10, moduleName: "User Management", SubModuleId: 3, SubModuleName: "Profile", expectedRoles: ["SYS_ADMIN", "ADMIN"], },
      },
      {
        title: "Add New User",
        link: "/pages/users/register",
        icon: "person-add-outline",
        data: { moduleId: 10, moduleName: "User Management", SubModuleId: 4, SubModuleName: "Add New User", expectedRoles: ["SYS_ADMIN", "ADMIN"], },
      },
    ],
  },
  {
    title: "Settings",
    icon: "settings-outline",
    data: { moduleId: 11, moduleName: "Settings", SubModuleName: "Root", expectedRoles: ["SYS_ADMIN", "ADMIN"], },
    children: [
      // {
      //   title: 'Features',
      //   link: '/pages/features/list',
      //   icon: 'list-outline'
      // },
      {
        title: "Audit",
        link: "/pages/audit/list",
        icon: "edit-2-outline",
        data: { moduleId:11, moduleName: "Settings", SubModuleId: 1, SubModuleName: "Audit" },
      },
    ],
  },
];
